import { withMetadata } from '../metadata'
import { isSupportedCountry as _isSupportedCountry } from '../../core/index'

export function isSupportedCountry() {
	return withMetadata(_isSupportedCountry, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/isSupportedCountry.js
// module id = T1fv
// module chunks = 0 1